module.exports = __webpack_public_path__ + "static/media/work-gea.5c2243c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/work-gea.jpg
// module id = 220
// module chunks = 0